export function eixoCategoria(nome: string, dados: string[]) {
    return {
        type: 'category',
        name: nome,
        nameLocation: 'middle',
        nameTextStyle: { fontSize: 14, padding: [12, 0, 0, 0] },
        data: dados,
        axisTick: { show: false },
        axisLine: { lineStyle: { color: '#333', width: 1 } },
        axisLabel: { fontSize: 12, interval: 0 },
    };
}

/**
 * Eixo de valor fixo 0-100, exclusivo para severidade. A escala e fechada
 * porque severidade e prob x impacto com ambos no dominio {1,2,5,8,10}
 * (D4/D2). Um eixo de contagem ou frequencia tem escala aberta e precisa
 * de outra funcao — nao reutilize esta para isso.
 */
export function eixoSeveridade(nome: string) {
    return {
        type: 'value',
        name: nome,
        nameLocation: 'middle',
        nameTextStyle: { fontSize: 14, padding: [0, 0, 10, 0] },
        min: 0,
        max: 100,
        splitLine: { show: true },
        axisLine: { lineStyle: { color: '#333', width: 2 } },
        axisTick: { show: true },
        axisLabel: { fontSize: 14 },
    };
}

